<template>
  <div
    class="header"
    :class="{
      'header--sortable': !!canSort,
      'header--sorted': column.id === sortBy,
    }"
  >
    <div
      class="name"
      @click="setSortBy"
    >
      <div class="name__view name__view--lg">
        {{ column.name }}
      </div>
      <div class="name__view name__view--sm">
        {{ column.shortName }}
      </div>
    </div>
    <div
      v-if="filter"
      class="filter"
    >
      <Button
        v-b-popover.hover.blur.top="hasFilterValue ? 'Изменить фильтр' : 'Применить фильтр'"
        size="small"
        :icon="{
          icon: 'filter-column',
          activeColor: 'blue',
        }"
        :active="hasFilterValue"
        no-border
        @click="$emit('filter', { column, filter })"
      />
    </div>
  </div>
</template>

<script>
import Button from "@/components/controls/button";

export default {
  components: {
    Button,
  },
  props: {
    column: {
      type: Object,
      required: true,
    },
    filter: {
      type: Object,
      default: null,
    },
    canSort: {
      type: Boolean,
      default: false,
    },
    sortBy: {
      type: String,
      default: "",
    },
    sortDir: {
      type: String,
      default: "",
    },
  },
  computed: {
    hasFilterValue () {
      return this.filter && !!this.filter.value;
    },
  },
  methods: {
    setSortBy() {
      if (!this.canSort) {
        return;
      }
            
      const { id } = this.column;

      let { sortBy, sortDir } = this;

      if (sortBy !== id) {
        sortBy = id;
        sortDir = null;
      }

      if (!sortDir) {
        sortDir = "asc";
      } else if (sortDir === "asc") {
        sortDir = "desc";
      } else {
        sortBy = null;
        sortDir = null;
      }

      this.$emit("sort", { sortBy, sortDir });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/vars';

.header {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 13px;

  @include onlyMobile {
    height: auto;
    gap: 0;
  }

  &--sortable .name {
    cursor: pointer;
  }

  &--sorted .name {
    color: $color-primary;
  }
}

.name {
  user-select: none;

  &__view--sm {
    display: none;
  }

  @include onlyMobile {
    &__view--lg {
      display: none;
    }
    
    &__view--sm {
      display: block;
    }
  }
}

.filter {
  align-self: flex-end;
  margin-top: auto;
  margin-right: -3px;
  transform: rotateY(180deg);
}
</style>
